// extracted by mini-css-extract-plugin
export default {"pAlert":"FormShipment_pAlert__nt7c7","pAlertt":"FormShipment_pAlertt__FKIC+","status":"FormShipment_status__Z-TDY","minWidth80":"FormShipment_minWidth80__IYUXE"};